import axios from 'axios';

export const dashboardService = {
  getDashboard: () =>
    axios.get('/dashboard', { auth: true }),
};
